import { Controller } from 'stimulus';
export default class extends Controller {
  connect() {
    $('#review_print_review_type').select2({
      width:'100%',
      placeholder: 'Select Type',
      templateResult: formatData,
      templateSelection: formatData,
      minimumResultsForSearch: -1
    });

    $('#review_print_review_type').on('select2:select', function (event) {
      $("#review_print_subject > option").each(function() {
        this.remove();
      });

      switch(event.params.data.id) {
        case 'core':
          $('#review_print_subject').append(new Option('A Person Inside Your Organization', 'person'));
          $('#review_print_subject').append(new Option('Your Company', 'agency'));
          $('#review_print_subject').append(new Option('Process', 'process'));
          $('#review_print_reviewee').attr('placeholder', 'Examples: Recruiter, Salesperson, Hiring Manager')
          break;
        case 'external':
          $('#public-profile-option').hide();
          $('#review_print_subject').append(new Option('Other' ,'thing'));
          $('#review_print_reviewee').attr('placeholder', 'Examples: Department, Onboarding Process')
          break;
        case 'anonymous':
          $('#public-profile-option').hide();
          $('#review_print_subject').append(new Option('Internal Feedback', 'internal'));
          $('#review_print_reviewee').attr('placeholder', 'Examples: Department, Onboarding Process')
          break;
      }
    });

    function formatData(data) {
      if (!data.id) {
        return data.text;
      }
      if (data.selected) {
        $('#hiddenFieldsGroup').show()
        $('#submitBtn').attr('disabled', false);
      }
      var image = data.element.attributes.dataimage.nodeValue;
      if(!image) {
        return opt.text;
      }
      else {
        var $data = $(
          '<span><img src="' + image + '"width="33rem" style="margin-right: 0.5rem"/>' +
            '<span style="font-size: 0.9rem;">'+ data.text + '</span>' +
          '</span>'
        );
        return $data;
      }
    };
  }
}
